export {
	adminIcon,
	alignIcon,
	analyticsIcon,
	assetsIcon,
	bambooIcon,
	bitbucketDataCenterIcon,
	bitbucketIcon,
	chatIcon,
	companyHubIcon,
	compassIcon,
	confluenceDataCenterIcon,
	confluenceIcon,
	crowdIcon,
	customLinkIcon,
	customerServiceManagementIcon,
	dxIcon,
	focusIcon,
	goalsIcon,
	guardDetectIcon,
	guardIcon,
	homeIcon,
	hubIcon,
	jiraDataCenterIcon,
	jiraIcon,
	jiraProductDiscoveryIcon,
	jiraServiceManagementDataCenterIcon,
	jiraServiceManagementIcon,
	loomIcon,
	loomInternalIcon,
	moreAtlassianAppsIcon,
	opsgenieIcon,
	projectsIcon,
	rawIcons,
	rovoDevAgentIcon,
	rovoDevIcon,
	rovoHexIcon,
	rovoIcon,
	searchIcon,
	statuspageIcon,
	studioIcon,
	talentIcon,
	teamsIcon,
	trelloIcon,
} from '../artifacts/raw-icons/index';
